import React from 'react';
import clsx from 'clsx';
import IconButton from './IconButton';

const RowAddButton = ({
  dataPosition = 'top right',
  className,
  disabled,
  entity,
  onClick,
  size,
}) => (
  <IconButton
    basic
    className={clsx('aridhia-row-add-button', className)}
    dataPosition={dataPosition}
    disabled={disabled}
    floated="right"
    icon
    iconClassName="primary"
    iconName="plus"
    iconOnly
    messageId={`actions.add.${entity}.row`}
    onClick={onClick}
    size={size}
  />
);

export default RowAddButton;
